import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { LogInPayload, TokenSet } from './types';

export const authInitRequest = action(
  'AUTH_INIT_REQUEST',
  withoutPayload,
);
export const authInitSuccess = action(
  'AUTH_INIT_SUCCESS',
  withPayload<TokenSet & {
    remember: string;
  }>(),
);
export const authInitFail = action(
  'AUTH_INIT_FAIL',
  withoutPayload,
);

export const unauthorizedRequest = action(
  'AUTH_UNAUTHORIZED_REQUEST',
  withoutPayload,
);

export const logInRequest = action(
  'AUTH_LOG_IN_REQUEST',
  withPayload<LogInPayload>(),
);
export const logInSuccess = action(
  'AUTH_LOG_IN_SUCCESS',
  withPayload<TokenSet>(),
);
export const logInFail = action(
  'AUTH_LOG_IN_FAIL',
  withoutPayload,
);

export const refreshRequest = action(
  'AUTH_REFRESH_REQUEST',
  withoutPayload,
);

export const refreshSuccess = action(
  'AUTH_REFRESH_SUCCESS',
  withPayload<TokenSet>(),
);
export const refreshFail = action(
  'AUTH_REFRESH_FAIL',
  withoutPayload,
);

export const logOut = action(
  'AUTH_LOG_OUT',
  withoutPayload,
);
